/**
 * Create a default sort for ReactTable
 */
export const setDefaultTableSort = (sort) => {
    let sortArray = [];
    let sortObject = {};
    if (sort && sort.field) {
        if (sort.field) {
            sortObject.id = sort.field;
        }
        if (sort.order) {
            sortObject.desc = (sort.order === 'DESC');
        }
        sortArray.push(sortObject);
    }
    return sortArray;
};

/**
 * Get current ReactTable state (for sorting and filtering)
 *
 * @param table
 * @return {*}
 */
export const getTableState = (table) => {
    const tableState = table.getResolvedState();
    if (tableState) {
        const tableData = tableState.sortedData;
        if (tableData && tableData.length > 0) {
            return tableData;
        }
    }
    return [];
};

/**
 * Filter number or string columns (case-insensitive)
 *
 * @param filter
 * @param row
 * @return {boolean}
 */
export const filterCaseInsensitive = (filter, row) => {
    const id = filter.pivotId || filter.id;
    if (row[id] !== null && typeof row[id] === 'string') {
        return (
            (row[id] !== undefined)
                ? String(row[id].toLowerCase()).indexOf(filter.value.toLowerCase()) !== -1
                : true
        )
    } else {
        return (
            String(row[filter.id]).indexOf(filter.value) !== -1
        )
    }
};


// WEBPACK FOOTER //
// ./src/Fuse/shared/tableFunctions.js